import { signalStoreFeature, withMethods, withProps } from "@ngrx/signals";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

export const withSnackBarFeature = () => signalStoreFeature(
  withProps((store) => ({
    _snackBar: inject(MatSnackBar),
    store
  })),
  withMethods(({ _snackBar }) => {
    /**
     * @SNACKBAR OPERATIONS
     * */
    const _snackBarMessage = (message: string, action = '', duration: number)=> {
      _snackBar.open(message, action, {
        duration: duration,
        horizontalPosition: 'start',
        verticalPosition: 'bottom',
      });
    };
    /**
     * @SNACKBAR OPERATIONS END
     * */
    return {
      displaySnackBar: (message: string, action = '', duration = 5000)=>
        _snackBarMessage(message, action, duration)
    }
  })
)
